import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    height: "100%",
    width: "100%",
    padding: "17px",
    lineHeight: "1.7",
  },
  landscapeContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  landscapeLeftSection: {
    flexDirection: "row",
    width: "50%",
    paddingRight: "20px",
  },
  landscapeRightSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "50%",
    paddingLeft: "20px",
  },
  landscapeArrowContainer: {
    fontSize: "6px",
    height: "40px",
    color: "#FF0000",
    alignSelf: "flex-end",
    transform: "rotate(-90deg)",
  },
  landscapeSideContainer: {
    fontSize: "6px",
    width: "40px",
    color: "#FF0000",
  },
  landscapeArrowPosition: {
    position: "absolute",
    top: "96%",
  },
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "17px 57px",
    width: "100%",
    height: "100%",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  portraitContainer: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    height: "100%",
  },
  portraitLeftSection: {
    flexDirection: "column",
    height: "100%",
  },
  landscapeLeft: {
    flexDirection: "row",
    width: "50%",
  },
  landscapeRight: {
    flexDirection: "row",
    textAlign: "right",
    width: "50%",
  },
  arrowIconCont: {
    fontSize: "6px",
    color: "#FF0000",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  pointingText: {
    marginBottom: "3px",
    marginTop: "-13px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
  landscapeArrowSetting: {
    height: "40px",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "6px",
  },
});

const MyDocument26 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  let landscapePagesArray = [];
  const landscapePages = () => {
    let k = 0,
      l = 1,
      n = 7,
      m = 6;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <View style={Styles.portraitContainer}>
          <View style={[Styles.portraitLeftSection, { textAlign: "right" }]}>
            <View style={{ flexDirection: "column", height: "50%" }}>
              <View style={Styles.landscapeArrowSetting}>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { transform: "rotate(-90deg)" }]}
                ></Image>
              </View>
              <View style={{ height: "80%" }}>
                <View
                  style={[
                    {
                      textAlign: "right",
                    },
                  ]}
                >
                  {arabicText(arabChunks[i + k])}
                </View>
              </View>
            </View>
            <View style={{ flexDirection: "column", height: "50%" }}>
              <View style={[Styles.landscapeArrowSetting, { height: "57px" }]}>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { transform: "rotate(-90deg)" }]}
                ></Image>
              </View>
              <View style={{ height: "80%" }}>
                <View
                  style={[
                    {
                      textAlign: "right",
                    },
                  ]}
                >
                  {arabicText(arabChunks[i + l])}
                </View>
              </View>
            </View>
          </View>
          <View style={Styles.portraitLeftSection}>
            <View style={{ flexDirection: "column", height: "50%" }}>
              <View style={{ height: "40px", alignSelf: "flex-end" }}></View>
              <View
                style={{
                  height: "80%",

                  justifyContent: "flex-start",
                  marginBottom: "6px",
                  transform: "rotate(180deg)",
                }}
              >
                {engChunks[n - i]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
              <View
                style={{
                  height: "57px",
                  alignSelf: "flex-end",
                  marginTop: "4px",
                }}
              >
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[
                    Styles.arrowIcon,
                    {
                      transform: "rotate(90deg)",
                    },
                  ]}
                ></Image>
              </View>
            </View>
            <View style={{ flexDirection: "column", height: "50%" }}>
              <View>
                <View style={{ height: "40px", alignSelf: "flex-end" }}></View>
                <View style={{ height: "80%", transform: "rotate(180deg)" }}>
                  {engChunks[m - i]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View
                  style={{
                    height: "40px",
                    alignSelf: "flex-end",
                    marginTop: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[Styles.arrowIcon, { transform: "rotate(90deg)" }]}
                  ></Image>
                </View>
              </View>
            </View>
          </View>
        </View>
      );
      k = k + 1;
      l = l + 1;
      n = n - 1;
      m = m - 1;
    }
  };
  landscapePages();
  return (
    <Document>
      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={Styles.landscapeContainer}>
          <View style={Styles.landscapeLeftSection}>
            <View style={Styles.landscapeSideContainer}></View>
            <View style={{ flexDirection: "column", width: "100%" }}>
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { marginRight: "-15px" },
                ]}
              >
                <Text style={Styles.pointingText}>بداية النص</Text>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { marginTop: "3px" }]}
                ></Image>
              </View>
              <View
                style={[
                  {
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[0])}
              </View>
            </View>
          </View>
          <View style={Styles.landscapeRightSection}>
            <View
              style={{
                width: "100%",
                flexDirection: "column",
                transform: "rotate(180deg)",
              }}
            >
              {engChunks[7]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
              <View
                style={{
                  alignSelf: "flex-end",
                  position: "absolute",
                  top: "-20px",
                  left: "0px",
                }}
              >
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[
                    Styles.arrowIcon,
                    { transform: "rotate(-90deg)", marginTop: "3px" },
                  ]}
                ></Image>
              </View>
            </View>
            <View
              style={[
                Styles.landscapeSideContainer,
                { alignItems: "flex-end" },
              ]}
            >
              <View style={{ transform: "rotate(180deg)", marginTop: "30px" }}>
                <Text style={Styles.pointingText}>End of text</Text>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
          </View>
        </View>
      </Page>

      {landscapePagesArray.map((array, index) => {
        return (
          <Page size="A4" style={Styles.portraitPage} key={index}>
            {array}
          </Page>
        );
      })}

      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={[Styles.landscapeContainer]}>
          <View style={[Styles.landscapeLeftSection]}>
            <View style={Styles.landscapeSideContainer}>
              <View style={{ position: "absolute", top: "87%" }}>
                <Text style={Styles.pointingText}>نهاية النص</Text>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
            <View
              style={{
                flexDirection: "column",
                width: "100%",
              }}
            >
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { marginRight: "-20px" },
                ]}
              >
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={Styles.arrowIcon}
                ></Image>
              </View>
              <View
                style={[
                  {
                    textAlign: "right",
                    marginBottom: "40px",
                  },
                ]}
              >
                {arabicText(arabChunks[7])}
              </View>
            </View>
          </View>
          <View
            style={[
              Styles.landscapeRightSection,
              { marginTop: "40px", marginBottom: "40px" },
            ]}
          >
            <View
              style={{
                width: "100%",
                flexDirection: "column",
                transform: "rotate(180deg)",
              }}
            >
              {engChunks[0]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
            <View
              style={[Styles.landscapeSideContainer, { marginLeft: "5px" }]}
            >
              <View
                style={{
                  transform: "rotate(180deg)",
                  position: "absolute",
                  top: "98%",
                }}
              >
                <Text style={Styles.pointingText}>Start of text</Text>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument26;
